import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModalOptions, NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IBackgroundModel, IBackgroundFile } from 'src/app/core/models/background.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { BackgroundService } from 'src/app/core/services/background.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'app-profile-backgrounds-list',
  templateUrl: './profile-backgrounds-list.component.html',
  styleUrls: ['./profile-backgrounds-list.component.css']
})
export class ProfileBackgroundsListComponent implements OnInit {


  @Output() addItem = new EventEmitter<string>();
  @Output() deleteBgFile = new EventEmitter<string>();

  @Input() secondProfilesOnThePage: boolean;
  @Input() darkMode: boolean;

  searchBgParam: string;
  selectedBackgrounds: any[] = [];
  selectedBackground = 'Select backgrounds...';

  newBackgrounds: IBackgroundModel[];
  allNewBackgrounds: IBackgroundModel[];
  backgroundSearch: IBackgroundModel[];
  showMyContainer = false;

  currentUser;
  BgToDelete: any;
  private modalDeleteFile: NgbModalRef;
  private dialogOptions: NgbModalOptions = {
    backdropClass: 'dark-backdrop',
    centered: true,
    windowClass: 'window-modal'
  };



  constructor(
    private backgroundService: BackgroundService,
    private authService: AuthService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.authService.LoggedinUser
      .subscribe(
        user => {
          this.currentUser = user;
        }
      );

    this.translate.get(['user.selectBackgrounds']).subscribe((values) => {
      this.selectedBackground = values['user.selectBackgrounds'];
    });
    if (this.secondProfilesOnThePage === false) {
      this.loadAllNewBackgrounds();
      this.loadNewBackgrounds();
    } else {
      this.loadAllNewBackgrounds2();
      this.loadNewBackgrounds2();
    }
  }

  loadAllNewBackgrounds() {
    this.backgroundService.allNewBackgrounds.subscribe(
      (bg) => {
        this.allNewBackgrounds = bg;
        this.backgroundSearch = bg;
      }
    )
  }

  loadNewBackgrounds() {
    this.backgroundService.newBackgrounds.subscribe(
      (bg) => {
        this.newBackgrounds = bg;
      }
    )
  }

  loadAllNewBackgrounds2() {
    this.backgroundService.allNewBackgrounds2.pipe(
      delay(500)).subscribe(
        (bg) => {
          this.allNewBackgrounds = bg;
          this.backgroundSearch = bg;
        }
      )
  }

  loadNewBackgrounds2() {
    this.backgroundService.newBackgrounds2.pipe(
      delay(500)).subscribe(
        (bg) => {
          this.newBackgrounds = bg;
        }
      )
  }

  openDropdown() {
    this.showMyContainer = !this.showMyContainer;
    this.searchBgParam = '';
    this.backgroundSearch = this.allNewBackgrounds;
  }

  applyBackgroundFilter() {
    this.backgroundSearch = this.allNewBackgrounds.filter(bg =>
      bg.name.toLowerCase().includes(this.searchBgParam.toLowerCase())
    );
  }

  addBackground(backgroundId) {
    const isAssigned = this.newBackgrounds?.some(bg => bg.id === backgroundId);
    if (isAssigned) {
      this.translate.get('user.bgAlreadyAssigned').subscribe((text: string) => {
        this.toastr.error(text);
      });
      return;
    }
    this.addItem.emit(backgroundId);
  }

  showDialogDeleteBg(content, file: any) {
    this.BgToDelete = file;
    this.modalDeleteFile = this.modalService.open(content, this.dialogOptions);
  }

  deleteBackground() {
    this.deleteBgFile.emit(this.BgToDelete.id);
    this.newBackgrounds.splice(this.newBackgrounds.findIndex(bg => bg.id == this.BgToDelete.id), 1);
    this.secondProfilesOnThePage ? this.backgroundService.setNewBackgrounds2(this.newBackgrounds) : this.backgroundService.setNewBackgrounds(this.newBackgrounds);
    this.modalDeleteFile.close();
  }

  backgroundPage = 1;
  backgroundPerPage = 8;
  jumpToBackgroundPage(event: any) {
    this.backgroundPage = event;
  }

}
